import { render } from "./ArtistCardDemogra.vue?vue&type=template&id=02262ce4&scoped=true"
import script from "./ArtistCardDemogra.vue?vue&type=script&lang=js"
export * from "./ArtistCardDemogra.vue?vue&type=script&lang=js"

import "./ArtistCardDemogra.vue?vue&type=style&index=0&id=02262ce4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02262ce4"]])

export default __exports__